/** @jsxImportSource @emotion/react */
"use client";
import { type Interpolation } from "@emotion/react";
import type { CommunityBroadcast } from "@packages/sdk";
import { Avatar, Skeleton, spacing } from "@packages/ui";
import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import { BroadcastMessage } from "./BroadcastMessage";

const baseStyles: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.ms,
};

const cardStyles: Interpolation = {
  height: 150,
  width: spacing.full,
};

const headerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  gap: spacing.s,
};

const headerTextStyles: Interpolation = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: spacing.t,
};

const headerTextNameStyles: Interpolation = {
  height: 18,
  width: "75%",
};

const headerTextTimeStyles: Interpolation = {
  height: spacing.m,
  width: "25%",
};

type BroadcastProps = Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
  data: CommunityBroadcast;
  loading?: boolean;
};

export const Broadcast = forwardRef<HTMLDivElement, BroadcastProps>(
  ({ data, loading = false, ...props }, ref) => {
    if (!data || loading)
      return (
        <div ref={ref} css={baseStyles} {...props}>
          <div css={headerStyles}>
            <Avatar loading size={40} />
            <div css={headerTextStyles}>
              <Skeleton css={headerTextNameStyles} />
              <Skeleton css={headerTextTimeStyles} />
            </div>
          </div>
          <Skeleton css={cardStyles} />
        </div>
      );

    return <BroadcastMessage data={data} {...props} />;
  },
);

Broadcast.displayName = "Broadcast";
